import React from 'react'

const ResetSearch = () => {
  return (<div className={'bb-search-autocomplete-box-clear'}>✕</div>)
}
export default ResetSearch
